import { gql } from "@edreamsodigeo/frontend-api-client";

import USER_FRAGMENT from "../userFragment/userFragment";

const LOGIN_RESPONSE_FRAGMENT = gql`
  ${USER_FRAGMENT}
  fragment LoginResponseParts on LoginResponse {
    success
    user {
      ...UserParts
    }
  }
`;

export default LOGIN_RESPONSE_FRAGMENT;
